import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Drawer, Translate } from '@/components';
import styles from './OrgProfileDrawer.styles';

interface OrgProfileDrawerProps {
  showOptions: boolean;
  setShowOptions: (show: boolean) => void;
}

const OrgProfileDrawer: React.FC<OrgProfileDrawerProps> = ({
  showOptions,
  setShowOptions,
}) => {
  const options = [
    {
      name: 'Contact',
      action: () => {
        console.log('contact');
      },
    },
    {
      name: 'Report',
      action: () => {
        console.log('report');
      },
    },
  ];
  return (
    <Drawer
      title="Profile Options"
      isOpen={showOptions}
      onToggle={setShowOptions}
    >
      {options.map(option => (
        <ListItem disablePadding key={option.name} onClick={option.action}>
          <ListItemButton>
            <ListItemText
              primary={<Translate>{option.name}</Translate>}
              className={styles.drawerItem}
            />
          </ListItemButton>
        </ListItem>
      ))}
    </Drawer>
  );
};

export default OrgProfileDrawer;
